var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-hub mini-loader"},[_c('div',{staticClass:"mb-4"},[_c('PuSkeleton',{attrs:{"height":"2rem"}})],1),_c('PuSkeleton',{attrs:{"count":3}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }